var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1407_14660)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 12.0707C24.5 5.40424 19.1274 0 12.5 0C5.87258 0 0.5 5.40424 0.5 12.0707C0.5 18.0956 4.88823 23.0893 10.625 23.9948V15.5599H7.57812V12.0707H10.625V9.41139C10.625 6.38617 12.4165 4.71513 15.1576 4.71513C16.4705 4.71513 17.8438 4.95088 17.8438 4.95088V7.92141H16.3306C14.8399 7.92141 14.375 8.85187 14.375 9.80645V12.0707H17.7031L17.1711 15.5599H14.375V23.9948C20.1118 23.0893 24.5 18.0956 24.5 12.0707Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1407_14660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8543c2406486fc214cf19d79b8f38089.svg";
export { ForwardRef as ReactComponent };